import { render, staticRenderFns } from "./phone-button.vue?vue&type=template&id=736c1396&"
import script from "./phone-button.vue?vue&type=script&lang=js&"
export * from "./phone-button.vue?vue&type=script&lang=js&"
import style0 from "./phone-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736c1396')) {
      api.createRecord('736c1396', component.options)
    } else {
      api.reload('736c1396', component.options)
    }
    module.hot.accept("./phone-button.vue?vue&type=template&id=736c1396&", function () {
      api.rerender('736c1396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/phone-button.vue"
export default component.exports